"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[36313],{

/***/ 136313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RelatedProducts": function() { return /* binding */ RelatedProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(309396);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(634655);





const RelatedProducts = (param)=>{
    let { relatedProducts  } = param;
    const { isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useTenantConfig */ .Wx)();
    if (!relatedProducts.length) return null;
    const arrowStyle = {
        backgroundColor: "white",
        borderRadius: 999,
        boxShadow: "rgba(0, 0, 0, 0.2) 0px 5px 15px"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HorizontalProductWrapper, {
        isMobile: isMobile,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_2__/* .ProductCarouselWithHeader */ .B, {
            header: {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Sản phẩm tương tự"),
                style: {
                    height: "".concat(isMobile ? "2.75rem" : "2.8rem"),
                    alignItems: "flex-end"
                }
            },
            products: relatedProducts,
            productsPerRow: isMobile ? 2.5 : 6.5,
            dividerColor: "divider",
            regionName: "relatedProducts",
            style: {
                minHeight: "auto"
            },
            customStyleLeftArrow: arrowStyle,
            customStyleRightArrow: arrowStyle,
            desktopProps: {
                perSwipe: "",
                bound: true
            }
        })
    });
};
const HorizontalProductWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div((param)=>{
    let { isMobile  } = param;
    return "\n  background: #fff;\n  margin-top: 8px;\n  border-radius: 16px;\n\n  .wrapper-horizontal-slider {\n    padding: 0px 8px;\n  }\n\n  .title {\n  ".concat(isMobile ? "font-size: 18px;\n    line-height: 24px;" : "font-size: 20px;\n    line-height: 28px;", "\n    \n    font-weight: 700;\n  }\n");
});


/***/ })

}]);